// extracted by mini-css-extract-plugin
module.exports = {"window":"_2640IlAGi5naCb4xa-ISeT"};